import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { isEnded } from '../../../utility/isEnded';

const TherapyDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedArr = documents?.toSorted((n1, n2) => sortPartialDate(n2.date, n1.date));
  const activeTherapies = sortedArr ? sortedArr.filter((at: ITherapy) => !isEnded(at?.endDate)) : [];
  const endedTherapies = sortedArr ? sortedArr.filter((et: ITherapy) => isEnded(et?.endDate)) : [];

  const { formatMessage } = useIntl();

  const therapyTitle = (ther: ITherapy) => {
    if (ther.otherTherapyType) return ther.otherTherapyType;
    if (ther.therapyTypes) return <FormattedMessage id={`therapy.opts.${ther?.therapyTypes}`} />;
    if (ther.therapyClassification)
      return <FormattedMessage id={`therapy.therapyClassification.opts.${ther.therapyClassification}`} />;
    return '';
  };

  return (
    <TileContentMaker
      type="listWithSubheaders"
      data={{
        nokey: {
          data: activeTherapies.map(a => ({
            date: isPartialDate(a.date) ? formatPartialDate(a.date) : '',
            title: therapyTitle(a),
            key: a._id,
          })),
          type: 'recentList',
        },
        [formatMessage({ id: 'therapy.inActiveTherapies' })]: {
          data: endedTherapies.map(a => ({
            date: isPartialDate(a.date) ? formatPartialDate(a.date) : '',
            title: therapyTitle(a),
            endDate: isPartialDate(a.endDate) ? formatPartialDate(a.endDate) : null,
            key: a._id,
          })),
          type: 'recentList',
        },
      }}
    />
  );
};

interface IOwnProps {
  documents: ITherapy[];
}

export default TherapyDash;
